/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { Typography } from '../typography';

const FigCaption = ({ caption, copyright, ...props }) => {
	return (
		<figcaption
			css={css`
				padding-top: 0.3em;
			`}
			{...props}
		>
			{!!copyright && (
				<Typography
					size="xs"
					weight="thin"
					css={css`
						letter-spacing: 0.1em;
						margin: 0.1em 0;
						margin-left: auto;
						text-align: right;
						text-transform: uppercase;
					`}
				>
					© {copyright}
				</Typography>
			)}
			{!!caption && (
				<Typography
					size="s"
					css={css`
						margin: 0.1em 0;
					`}
				>
					{caption}
				</Typography>
			)}
		</figcaption>
	);
};

export default FigCaption;
